import { useState, useEffect } from "react";

// Components
import Text from "components/common/Text";
import Image from "next/image";

// Libs
import Translation from "libs/Translation";

const ContactInfo = ({ center, mobileView, webConfig }) => {
  const items = [
    {
      id: 0,
      icon: "/nextasset/images/center/pin.png",
      alt: "location-icon",
      title: `${Translation.t("label.city")}:`,
      text: webConfig.lang === "fa" ? center?.City.Title : center?.City.Slug,
    },
    {
      id: 1,
      icon: "/nextasset/images/center/map.png",
      alt: "location-icon",
      title: Translation.t("label.address"),
      text: Translation.n(center?.Address),
    },
    {
      id: 2,
      icon: "/nextasset/images/doctorProfile/call.svg",
      alt: "phone-icon",
      title: Translation.t("label.phone-number"),
      text: Translation.n(center?.phoneNumber),
    },
  ];

  return (
    <div className="box padding-24">
      <div className="row-flex flex-title">
        {mobileView ? (
          <Image
            src="/nextasset/images/center/icon-3.png"
            width={28}
            height={28}
            alt="text-icon"
          />
        ) : (
          <Image
            src="/nextasset/images/center/icon-3.png"
            width={32}
            height={32}
            alt="text-icon"
          />
        )}
        <Text color="#0D2439" className="title">
          {Translation.t("title.contact-info")}
        </Text>
      </div>

      <div className="contact-info-list">
        {items.map((i) => (
          <>
            {i.text && (
              <div className="contact-info" key={i.id}>
                <div className="row-flex gap-5">
                  <Image alt={i.alt} src={i.icon} width={20} height={20} />
                  <Text tag="span" className="label">
                    {i.title}
                  </Text>
                </div>
                <Text className="value">{i.text}</Text>
              </div>
            )}
          </>
        ))}
      </div>
    </div>
  );
};
export default ContactInfo;
